// Precise, theme-matched eyewear dimension diagram (inline SVG for crisp labels).
export const DimensionDiagram = () => {
  const dim = "rgba(255,255,255,0.45)";
  const frame = "rgba(255,255,255,0.85)";
  const accent = "#8BA3B3";
  return (
    <svg viewBox="0 0 680 540" className="w-full h-auto" data-testid="dimension-diagram" role="img"
      aria-label="Diagram showing lens width 56mm, lens height 48mm, frame width 141mm and temple length 140mm">
      <defs>
        <marker id="arrow" markerWidth="8" markerHeight="8" refX="4" refY="4" orient="auto">
          <path d="M0,0 L8,4 L0,8 Z" fill={dim} />
        </marker>
        <marker id="arrowStart" markerWidth="8" markerHeight="8" refX="4" refY="4" orient="auto-start-reverse">
          <path d="M0,0 L8,4 L0,8 Z" fill={dim} />
        </marker>
      </defs>

      {/* ---- FRONT VIEW ---- */}
      <text x="40" y="34" fill={accent} fontSize="13" letterSpacing="3" fontFamily="Manrope, sans-serif">FRONT VIEW</text>

      {/* lenses */}
      <rect x="120" y="96" width="180" height="132" rx="30" fill="none" stroke={frame} strokeWidth="3" />
      <rect x="380" y="96" width="180" height="132" rx="30" fill="none" stroke={frame} strokeWidth="3" />
      {/* bridge */}
      <path d="M300,120 q40,-22 80,0" fill="none" stroke={frame} strokeWidth="3" />
      {/* hinges / temple stubs */}
      <path d="M120,120 q-26,2 -34,14" fill="none" stroke={frame} strokeWidth="3" />
      <path d="M560,120 q26,2 34,14" fill="none" stroke={frame} strokeWidth="3" />

      {/* frame width (top) */}
      <line x1="86" y1="66" x2="594" y2="66" stroke={dim} strokeWidth="1.5" markerStart="url(#arrowStart)" markerEnd="url(#arrow)" />
      <line x1="86" y1="60" x2="86" y2="128" stroke={dim} strokeWidth="1" strokeDasharray="3 3" />
      <line x1="594" y1="60" x2="594" y2="128" stroke={dim} strokeWidth="1" strokeDasharray="3 3" />
      <rect x="270" y="52" width="140" height="24" rx="6" fill="#0A0A0A" />
      <text x="340" y="69" fill={frame} fontSize="14" textAnchor="middle" fontFamily="Manrope, sans-serif">Frame width · 141 mm</text>

      {/* lens width (bottom of left lens) */}
      <line x1="120" y1="250" x2="300" y2="250" stroke={dim} strokeWidth="1.5" markerStart="url(#arrowStart)" markerEnd="url(#arrow)" />
      <line x1="120" y1="228" x2="120" y2="256" stroke={dim} strokeWidth="1" strokeDasharray="3 3" />
      <line x1="300" y1="228" x2="300" y2="256" stroke={dim} strokeWidth="1" strokeDasharray="3 3" />
      <text x="210" y="274" fill={frame} fontSize="14" textAnchor="middle" fontFamily="Manrope, sans-serif">Lens width · 56 mm</text>

      {/* lens height (left of left lens) */}
      <line x1="92" y1="96" x2="92" y2="228" stroke={dim} strokeWidth="1.5" markerStart="url(#arrowStart)" markerEnd="url(#arrow)" />
      <text x="86" y="166" fill={frame} fontSize="14" textAnchor="middle" fontFamily="Manrope, sans-serif" transform="rotate(-90 86 166)">Lens height · 48 mm</text>

      {/* ---- SIDE VIEW (temple) ---- */}
      <text x="40" y="366" fill={accent} fontSize="13" letterSpacing="3" fontFamily="Manrope, sans-serif">SIDE VIEW · TEMPLE ARM</text>

      {/* hinge block */}
      <rect x="96" y="404" width="26" height="34" rx="6" fill="none" stroke={frame} strokeWidth="3" />
      {/* temple arm with ear curve */}
      <path d="M122,421 L540,421 q34,0 40,30 q4,22 -14,34" fill="none" stroke={frame} strokeWidth="3" strokeLinecap="round" />

      {/* temple length arrow */}
      <line x1="122" y1="474" x2="566" y2="474" stroke={dim} strokeWidth="1.5" markerStart="url(#arrowStart)" markerEnd="url(#arrow)" />
      <line x1="122" y1="421" x2="122" y2="480" stroke={dim} strokeWidth="1" strokeDasharray="3 3" />
      <line x1="566" y1="451" x2="566" y2="480" stroke={dim} strokeWidth="1" strokeDasharray="3 3" />
      <text x="344" y="498" fill={frame} fontSize="14" textAnchor="middle" fontFamily="Manrope, sans-serif">Temple length · 140 mm</text>
    </svg>
  );
};
